<template>
    <v-layout>
        <transition name="el-fade-in" mode="out-in">
            <router-view></router-view>
            <!--<router-view v-if="$store.state.account.id"></router-view>-->
        </transition>
    </v-layout>
</template>

<script>
  /* ============
   * Home Index Page
   * ============
   *
   * The home index page.
   */

  import { createNamespacedHelpers } from 'vuex'
  import VLayout from '@/app/layouts/Default'

  const {mapActions} = createNamespacedHelpers('app')

  const handleRouteChange = (to, from, next) => {
    // Always redirect to dashboard when Home breadcrumb is clicked
    if (to.name === 'clo.home') {
      // @todo Make section param optional, use default value instead
      next({name: 'clo.dashboard', params: {section: 'clo'}})
    } else {
      next()
    }
  }

  export default {
    beforeRouteEnter (to, from, next) {
      handleRouteChange(to, from, next)
    },
    beforeRouteUpdate (to, from, next) {
      handleRouteChange(to, from, next)
    },
    /**
     * The name of the page.
     */
    name: 'home-index',
    /**
     * The components that the page can use.
     */
    components: {
      VLayout
    },
    methods: {
      ...mapActions(
        ['setSection']
      )
    },
    created () {
      // Store current application section (ex: Traditional/Clo)
      // to make it globally accessible via Vuex
      this.setSection({section: this.$route.params.section})
      // Update i18n locale based on stored locale
      this.$i18n.locale = this.$store.state.locale.current
      // Watch locale changes
      const context = this
      this.$store.watch(
        function (state) {
          return state.locale.current
        },
        function (val) {
          context.$i18n.locale = val
        }
      )
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/pages/Home/Index.vue